/**
 * Links for the profile consent statement. These are content/config URLs, not
 * API data, so they live here rather than being fetched.
 *
 * The privacy statement URL is the live WijMobiel one (also used in the eTicket
 * TermsStep). TODO(content): the terms-of-use URL is a placeholder until the
 * definitive "Gebruikersvoorwaarden" page exists — replace when available.
 */
export const PROFILE_CONSENT_LINKS = {
  privacy: 'https://wijmobiel.nl/privacy-statement/',
  terms: 'https://wijmobiel.nl/gebruikersvoorwaarden/',
} as const
